'use strict';
import React from 'react';
import PropTypes from 'prop-types';

const Table = (props) => {
    const {
        headers,
        headerSizes,
        maxHeight,
        children,
        type
    } = props;

    const isFixed = maxHeight !== 0;

    const tableWrapperStyle = {
        height: maxHeight,
        position: 'relative',
        overflow: 'visible',
        marginBottom: '60px',
        borderLeft: '0',
        borderTop: '0',
        borderRight: '0'
    };

    const tableContainerStyle = {
        height: '100%',
        overflowY: 'auto'
    };

    const thInnerStyle = {
        position: 'absolute',
        display: 'block',
        top: 0
    };

    const headerBackgroundStyle = {
        backgroundColor: '#f9f9f9',
        height: '60px'
    };

    if (isFixed)
        return (<div className="c-table-wrapper" style={tableWrapperStyle}>
            <div className="c-table__spacer" style={headerBackgroundStyle}/>
            <div className="c-table__container" style={tableContainerStyle}>
                <table className={"c-table  c-table--scrollable"} style={{ position: 'static' }}>
                    {headers ? <thead>
                        <tr>
                            {headers.map((header, i) => {
                                return headerSizes.length > 0 ?
                                    (<th key={i} width={headerSizes[i] + '%'}><span style={thInnerStyle}>{header}</span></th>) :
                                    (<th key={i}><span style={thInnerStyle}>{header}</span></th>);
                            })}
                        </tr>
                    </thead> : null}
                    <tbody>
                        {children}
                    </tbody>
                </table>
            </div>
        </div>);

    return (
        <table className={"c-table " + type}>
            {headers ? <thead>
                <tr>
                    {headers.map((header, i) => {
                        return headerSizes.length > 0 ?
                            (<th key={i} width={headerSizes[i] + '%'}>{header}</th>) :
                            (<th key={i}>{header}</th>);
                    })}
                </tr>
            </thead> : null}
            <tbody>
                {children}
            </tbody>
        </table>
    );
};

Table.defaultProps = {
    type: 'regular',
    headers: [],
    headerSizes: [],
    maxHeight: 0
};

Table.propTypes = {
    headers: PropTypes.array,
    headerSizes: PropTypes.array,
    type: PropTypes.string,
    maxHeight: PropTypes.number,
    children: PropTypes.node
};

export default Table;